import { render, staticRenderFns } from "./6-common.vue?vue&type=template&id=486d8e44&scoped=true&"
import script from "./6-common.vue?vue&type=script&lang=js&"
export * from "./6-common.vue?vue&type=script&lang=js&"
import style0 from "./6-common.vue?vue&type=style&index=0&id=486d8e44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "486d8e44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('486d8e44')) {
      api.createRecord('486d8e44', component.options)
    } else {
      api.reload('486d8e44', component.options)
    }
    module.hot.accept("./6-common.vue?vue&type=template&id=486d8e44&scoped=true&", function () {
      api.rerender('486d8e44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/details/6-common.vue"
export default component.exports